<app-form-generator
    *ngIf="formGenInput"
    [formGeneratorInput]="formGenInput"
    (formGroupRef)="formGroup = $event"
    (valuesChange)="fieldSelectionChange($event)"
></app-form-generator>
